// extracted by mini-css-extract-plugin
export default {"CompanyLogoGroup":"J4wRijI6GfUk4nZEj4tl","ChatbotLogo":"WFG7dhZiV7dMmOiUmT8a"};